// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__CC5VJ","file":"styles_file__2CjiD"};